import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import type { ReactElement } from 'react';

const isValidUrl = (string: string): boolean => {
  try {
    const url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

interface BootstrapTooltipProps extends Omit<TooltipProps, 'title'> {
  href?: string;
  target?: string;
  title?: TooltipProps['title'];
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export const BootstrapTooltip = ({
  href,
  target = '_blank',
  title,
  children,
  ...props
}: BootstrapTooltipProps) => {
  if (href && isValidUrl(href)) {
    const linkElement = (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        {children}
      </a>
    );

    return (
      <StyledTooltip title={title || href} {...props}>
        {linkElement}
      </StyledTooltip>
    );
  }

  return (
    <StyledTooltip title={title || href} {...props}>
      {children as ReactElement}
    </StyledTooltip>
  );
};
